import { AppRoutes } from "@domain/routing/routeConstants";
import type { GQL } from "@binale-tech/shared";
import { type ApolloClient, gql, type TypedDocumentNode } from "@apollo/client";

export const datevObtainAuthUrl: TypedDocumentNode<
    Pick<GQL.IMutation, "datevObtainAuthUrl">,
    GQL.IMutationDatevObtainAuthUrlArgs
> = gql`
    mutation datevObtainAuthUrl($input: DatevAuthUrlInput!) {
        datevObtainAuthUrl(input: $input) {
            url
        }
    }
`;

export const datevTokenRefresh: TypedDocumentNode<
    Pick<GQL.IMutation, "datevTokenRefresh">,
    GQL.IMutationDatevTokenRefreshArgs
> = gql`
    mutation datevTokenRefresh($input: DatevRefreshInput!) {
        datevTokenRefresh(input: $input) {
            id
            refreshTokenExpiresIn
            accessTokenExpiresIn
            issuedAt
        }
    }
`;

export const datevTokenRevoke: TypedDocumentNode<
    Pick<GQL.IMutation, "datevTokenRevoke">,
    GQL.IMutationDatevTokenRevokeArgs
> = gql`
    mutation datevTokenRevoke($companyId: ID) {
        datevTokenRevoke(companyId: $companyId)
    }
`;
export const DATEV_AUTH_LS_KEY = "datevOAuth";
export type DatevAuthLSData = {
    userId: string;
    companyId?: string;
};

export const redirectToDatevOAuth = async (
    client: ApolloClient,
    userId: string,
    company?: GQL.ICompany,
): Promise<void> => {
    const urlRes = await client.mutate({
        mutation: datevObtainAuthUrl,
        variables: {
            input: {
                redirectUri: window.location.href.split("/").slice(0, 3).join("/") + AppRoutes.datevCallback,
                companyId: company?.id,
            },
        },
    });
    localStorage.setItem(
        DATEV_AUTH_LS_KEY,
        JSON.stringify({
            userId,
            companyId: company?.id,
        } satisfies DatevAuthLSData),
    );
    window.open(urlRes.data.datevObtainAuthUrl.url, "_blank");
};
